/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSponsorLead = `
subscription MySubscription {
  onCreateSponsorLead
}
`;

export const onUpdateSponsorLead = `
subscription MySubscription {
  onUpdateSponsorLeads
}
`;

// export const onCreateSponsors = /* GraphQL */ `
//   subscription OnCreateSponsors($filter: ModelSubscriptionSponsorsFilterInput) {
//     onCreateSponsors(filter: $filter) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onUpdateSponsors = /* GraphQL */ `
//   subscription OnUpdateSponsors($filter: ModelSubscriptionSponsorsFilterInput) {
//     onUpdateSponsors(filter: $filter) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onDeleteSponsors = /* GraphQL */ `
//   subscription OnDeleteSponsors($filter: ModelSubscriptionSponsorsFilterInput) {
//     onDeleteSponsors(filter: $filter) {
//       id
//       eventId
//       sponsorName
//       sponsorEmail
//       leadsCount
//       sponsorCode
//       createdBy
//       updatedBy
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onCreateUserSponsorMapping = /* GraphQL */ `
//   subscription OnCreateUserSponsorMapping(
//     $filter: ModelSubscriptionUserSponsorMappingFilterInput
//     $owner: String
//   ) {
//     onCreateUserSponsorMapping(filter: $filter, owner: $owner) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const onUpdateUserSponsorMapping = /* GraphQL */ `
//   subscription OnUpdateUserSponsorMapping(
//     $filter: ModelSubscriptionUserSponsorMappingFilterInput
//     $owner: String
//   ) {
//     onUpdateUserSponsorMapping(filter: $filter, owner: $owner) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const onDeleteUserSponsorMapping = /* GraphQL */ `
//   subscription OnDeleteUserSponsorMapping(
//     $filter: ModelSubscriptionUserSponsorMappingFilterInput
//     $owner: String
//   ) {
//     onDeleteUserSponsorMapping(filter: $filter, owner: $owner) {
//       id
//       userId
//       eventId
//       leadsCount
//       sponsorCode
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//       owner
//     }
//   }
// `;
// export const onCreateSponsorAppAuthManagement = /* GraphQL */ `
//   subscription OnCreateSponsorAppAuthManagement(
//     $filter: ModelSubscriptionSponsorAppAuthManagementFilterInput
//   ) {
//     onCreateSponsorAppAuthManagement(filter: $filter) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onUpdateSponsorAppAuthManagement = /* GraphQL */ `
//   subscription OnUpdateSponsorAppAuthManagement(
//     $filter: ModelSubscriptionSponsorAppAuthManagementFilterInput
//   ) {
//     onUpdateSponsorAppAuthManagement(filter: $filter) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onDeleteSponsorAppAuthManagement = /* GraphQL */ `
//   subscription OnDeleteSponsorAppAuthManagement(
//     $filter: ModelSubscriptionSponsorAppAuthManagementFilterInput
//   ) {
//     onDeleteSponsorAppAuthManagement(filter: $filter) {
//       id
//       token
//       expiryTime
//       sponsorKey
//       createdAt
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onCreateSponsorLeads = /* GraphQL */ `
//   subscription OnCreateSponsorLeads(
//     $filter: ModelSubscriptionSponsorLeadsFilterInput
//   ) {
//     onCreateSponsorLeads(filter: $filter) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onUpdateSponsorLeads = /* GraphQL */ `
//   subscription OnUpdateSponsorLeads(
//     $filter: ModelSubscriptionSponsorLeadsFilterInput
//   ) {
//     onUpdateSponsorLeads(filter: $filter) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
// export const onDeleteSponsorLeads = /* GraphQL */ `
//   subscription OnDeleteSponsorLeads(
//     $filter: ModelSubscriptionSponsorLeadsFilterInput
//   ) {
//     onDeleteSponsorLeads(filter: $filter) {
//       id
//       eventId
//       sponsorCode
//       bookingId
//       name
//       emailId
//       phoneNumber
//       designation
//       organisation
//       comment
//       scannedBy
//       createdAt
//       status
//       updatedAt
//       _version
//       _deleted
//       _lastChangedAt
//     }
//   }
// `;
